<template>
  <v-container class="pa-4 pa-sm-8" fluid>
    <v-row class="mt-3 mt-sm-0">
      <h2 class="dark--text text-h5 font-weight-bold ms-3">
        Category Types
      </h2>
      <v-layout justify-end class="me-4 mt-6 mt-sm-0">
        <CategoryTypeForm v-show="false" v-if="hasRole(AdminUserPermissions.MEALS_CATEGORY_ADD)" class="me-2 me-md-0"></CategoryTypeForm>
        <AuditTrialLog class="ms-md-4" auditType="CATEGORY_TYPE_LOG" />
      </v-layout>
    </v-row>

    <v-system-bar height="1" class="mt-10"></v-system-bar>
    <v-data-table
      :mobile-breakpoint="0"
      :headers="headers"
      :items="itemsWithSno"
      class="elevation-1"
      :items-per-page="25"
      :options.sync="options"
      :loading="loading"
      :server-items-length="totalItemsCount"
      :footer-props="{ 'items-per-page-options': [25, 50, 100, 500] }"
    >
      <template v-slot:[`item.active`]="{ item }">
        <!-- <v-checkbox color="primary" disabled-color="primary" v-model="item.active" disabled></v-checkbox> -->
        <v-icon v-show="item.active" color="primary">mdi-checkbox-marked</v-icon>
        <v-icon v-show="!item.active" color="grey">mdi-checkbox-blank-outline</v-icon>
      </template>
      <template v-slot:[`item.pcValueNotRequired`]="{ item }">
        <v-icon v-show="item.pcValueNotRequired" color="primary">mdi-checkbox-marked</v-icon>
        <v-icon v-show="!item.pcValueNotRequired" color="grey">mdi-checkbox-blank-outline</v-icon>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-row>
          <app-category-update-form v-if="hasRole(AdminUserPermissions.MEALS_CATEGORY_EDIT)" :categoryInfo="item"></app-category-update-form>
        </v-row>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import CategoryTypeUpdateForm from "../components/CategoryTypeUpdateForm.vue";
import CategoryTypeForm from "../components/CategoryTypeForm";
import AuditTrialLog from "@/audit-trial-log/components/AuditTrialLog.vue";
export default {
  components: {
    "app-category-update-form": CategoryTypeUpdateForm,
    CategoryTypeForm,
    AuditTrialLog,
  },
  data() {
    return {
      categoryTypes: [],
      totalItemsCount: 25,
      variables: {
        limit: 25,
        skip: 0,
      },
      options: {
        itemsPerPage: 25,
        page: 1,
      },
      loading: true,
      headers: [
        {
          text: "#",
          value: "slNo",
          sortable: false,
        },
        { text: "Name", value: "nameEn", sortable: false },
        { text: "Name Ar", value: "nameAr", sortable: false },
        { text: "Active", value: "active", sortable: false },
        { text: "Show Order", value: "showOrder", sortable: false },
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },
  apollo: {
    getAllCategoryTypes() {
      return {
        query: require("@/menu-packages/api/getAllCategoryTypes.graphql"),

        result({ data, loading }) {
          this.loading = loading;
          this.categoryTypes = data.getAllCategoryTypes;
        },
      };
    },
  },

  computed: {
    itemsWithSno() {
      if (this.categoryTypes == null) return [];
      return this.categoryTypes.map((d, index) => ({ ...d, slNo: index + 1 }));
    },
  },
  methods: {},
  created() {
    if (!this.hasRole(this.AdminUserPermissions.MEALS_CATEGORY_VIEW)) {
      this.$router.push({
        name: "Error404",
      });
    }
  },
};
</script>
